<div class="text-center">
  <div class="spinner-border" [ngClass]="{ 'spinner-border-sm': size === 'small' }" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
